import $ from 'jquery';

class FilterEvents {
    constructor() {
        this.filters = '';
        this.init();
    }

    init() {
        $('.js-filters .js-filter-button').on('click', (e) => {
            this.filters = $(e.currentTarget).data('filter');
            this.filter();
            e.stopPropagation();
        });
    }

    filter() {
        let $toFilter = $('.js-to-filter');
        $toFilter.removeClass('hide');

        if (this.filters !== "*") {
            $toFilter.addClass('hide');
            $('.js-to-filter.js-filter-tag-' + this.filters).removeClass('hide');
        }

        let count = $toFilter.length - $('.js-to-filter.hide').length;
        let $noResults = $('.js-no-results');

        if (count === 0) {
            $noResults.removeClass('hide');
        } else {
            $noResults.addClass('hide');
        }
    }
}

export default FilterEvents;


// WEBPACK FOOTER //
// ./web/app/themes/stash/src/js/helpers/filter-events.js